<div class="modal-overlay" (click)="onBackdropClick($event)">
  <div
    class="modal-content"
    role="dialog"
    aria-modal="true"
    aria-label="Edit Background Definitions JSON"
  >
    <div class="modal-header">
      <h3>Edit Background Definitions (JSON)</h3>
      <button class="close-btn" (click)="cancel()" aria-label="Close">✕</button>
    </div>

    <div class="toolbar">
      <button (click)="format()">Format</button>
      <button (click)="reset()">Reset</button>
      <button (click)="validate()">Validate</button>
      <span class="error" *ngIf="errorMsg">{{ errorMsg }}</span>
    </div>

    <textarea
      class="json-editor"
      [(ngModel)]="_jsonText"
      spellcheck="false"
      rows="20"
    ></textarea>

    <div class="modal-footer">
      <button class="btn" (click)="cancel()">Cancel</button>
      <button class="btn primary" (click)="saveModal()">Save</button>
    </div>
  </div>
</div>
